module.exports = __webpack_public_path__ + "static/img/logo4.fc9fa5bb.png";